export const projectPageOrder = ["dossier-137", "phoenix", "lets-fall-in-love", "oscar-niemeyer", "workshop-mumbai", "synrgy", "fisheye", "aethera"];

export const projectPages = {
  "dossier-137": {
    num: "01",
    titleTop: "Dossier",
    titleBottom: "137",
    tagline: "Affiche cinéma — Festival de Cannes",
    taglineEn: "Film poster — Cannes Film Festival",
    year: "2025",
    meta: [
      { label: "Année", value: "2025" },
      { label: "Équipe", value: "Lili Le Biez & Chloé Rigallaud-Leal" },
      { label: "Type", value: "Affiche cinéma" },
      { label: "Support", value: "Key visual + affiche" },
    ],
    metaEn: [
      { label: "Year", value: "2025" },
      { label: "Team", value: "Lili Le Biez & Chloé Rigallaud-Leal" },
      { label: "Type", value: "Film poster" },
      { label: "Format", value: "Key visual + poster" },
    ],
    description:
      "Key visual et campagne d'affiche pour Dossier 137 de Dominik Moll, en compétition officielle au Festival de Cannes 2025. Un système graphique construit sur la trame, la marge et un rouge de prétoire.",
    descriptionEn:
      "Key visual and poster campaign for Dossier 137 by Dominik Moll, in official competition at the 2025 Cannes Film Festival. A graphic system built on the grid, the margin and a courtroom red.",
    pages: ["/images/dossier137/affiche-01.webp", "/images/dossier137/affiche-02.webp", "/images/dossier-137.webp"],
  },
  phoenix: {
    num: "02",
    titleTop: "Phoenix",
    titleBottom: null,
    tagline: "Pochette vinyle — Séminaire Britney Spears",
    taglineEn: "Vinyl sleeve — Britney Spears seminar",
    year: "2025",
    meta: [
      { label: "Année", value: "2025" },
      { label: "École", value: "ECV — DG2" },
      { label: "Type", value: "Pochette vinyle" },
      { label: "Support", value: "Dossier de rendu — 62 pages" },
    ],
    metaEn: [
      { label: "Year", value: "2025" },
      { label: "School", value: "ECV — DG2" },
      { label: "Type", value: "Vinyl sleeve" },
      { label: "Format", value: "Process book — 62 pages" },
    ],
    description:
      "Phoenix célèbre la résilience et la renaissance. Inspiré du mythe du phénix, ce projet fictif d'album déploie un univers visuel comme une métaphore des cycles de la vie — chute, introspection, élévation. Le contraste entre l'obscurité et des éclats de lumière porte le récit : le noir pour l'introspection, la lumière pour la force intérieure et l'espoir. Les flammes, réinterprétées dans des roses fluides et dansants, ne détruisent pas mais transforment — symbole de purification. Une silhouette blanche, volontairement anonyme, incarne un « moi intérieur » universel dans lequel chacun peut se projeter. Une esthétique épurée, presque minimale, pour laisser toute la place à l'émotion : sortir des ténèbres, embrasser sa lumière.",
    descriptionEn:
      "Phoenix celebrates resilience and rebirth. Inspired by the myth of the phoenix, this fictional album project unfolds a visual world as a metaphor for the cycles of life — falling, introspection, rising. The contrast between darkness and bursts of light carries the story: black for introspection, light for inner strength and hope. The flames, reinterpreted in fluid, dancing pinks, do not destroy but transform — a symbol of purification. A white, deliberately anonymous silhouette embodies a universal 'inner self' anyone can project themselves onto. A pared-back, almost minimal aesthetic leaves all the room to emotion: emerging from the darkness, embracing your own light.",
    pages: [
      "/images/phoenix/page-25.webp",
      "/images/phoenix/page-46.webp",
      "/images/phoenix/page-51.webp",
      "/images/phoenix/page-54.webp",
    ],
  },
  "lets-fall-in-love": {
    num: "03",
    titleTop: "Let's Fall",
    titleBottom: "in Love",
    tagline: "Éditorial & print — Romance 14.02",
    taglineEn: "Editorial & print — Romance 02.14",
    year: "2025",
    meta: [
      { label: "Année", value: "2025" },
      { label: "Type", value: "Éditorial & print" },
      { label: "Support", value: "Affiche — impression" },
      { label: "Palette", value: "Rose poudré & rouge" },
    ],
    metaEn: [
      { label: "Year", value: "2025" },
      { label: "Type", value: "Editorial & print" },
      { label: "Format", value: "Poster — print" },
      { label: "Palette", value: "Powder pink & red" },
    ],
    description:
      "Affiche éditoriale pour la Saint-Valentin : un titrage serif rouge sur dégradés rose poudré, ponctué de cœurs et de lettrines calligraphiées en filigrane. Une déclaration typographique, imprimée et photographiée in situ.",
    descriptionEn:
      "An editorial poster for Valentine's Day: red serif headlines over powder-pink gradients, punctuated with hearts and calligraphic drop caps in watermark. A typographic statement, printed and shot in situ.",
    pages: ["/images/lets-fall-in-love/page-01.webp", "/images/lets-fall-in-love.webp"],
  },
  "oscar-niemeyer": {
    num: "05",
    titleTop: "Oscar",
    titleBottom: "Niemeyer",
    tagline: "Design typographique",
    taglineEn: "Typographic design",
    year: "2026",
    meta: [
      { label: "Année", value: "2025 — 2026" },
      { label: "École", value: "ECV Bordeaux" },
      { label: "Type", value: "Design typographique" },
      { label: "Support", value: "Présentation typographique" },
    ],
    metaEn: [
      { label: "Year", value: "2025 — 2026" },
      { label: "School", value: "ECV Bordeaux" },
      { label: "Type", value: "Typographic design" },
      { label: "Format", value: "Typographic presentation" },
    ],
    description:
      "Une présentation typographique dédiée à l'architecte des courbes et du béton. Composer avec le vide comme Niemeyer composait avec la lumière : rythme, rupture et respiration.",
    descriptionEn:
      "A typographic presentation dedicated to the architect of curves and concrete. Composing with emptiness the way Niemeyer composed with light: rhythm, rupture and breathing space.",
    dir: "/images/niemeyer",
    total: 17,
    pages: [
      "/images/niemeyer/page-03.webp",
      "/images/niemeyer/page-12.webp",
      "/images/niemeyer/page-13.webp",
      "/images/niemeyer/page-14.webp",
      "/images/niemeyer/page-15.webp",
    ],
  },
  "workshop-mumbai": {
    num: "06",
    titleTop: "Workshop",
    titleBottom: "Mumbaï",
    tagline: "Affiche typographique — Échange ECV × WWI",
    taglineEn: "Typographic poster — ECV × WWI exchange",
    year: "2026",
    meta: [
      { label: "Année", value: "2026" },
      { label: "Contexte", value: "Workshop d'échange — Mumbaï" },
      { label: "Type", value: "Projet typographique" },
      { label: "Support", value: "Affiche — hindi & français" },
    ],
    metaEn: [
      { label: "Year", value: "2026" },
      { label: "Context", value: "Exchange workshop — Mumbai" },
      { label: "Type", value: "Typographic project" },
      { label: "Format", value: "Poster — Hindi & French" },
    ],
    description:
      "Affiche réalisée lors d'un workshop d'échange à Mumbaï : « Ça arrache » se glisse entre deux lignes de devanagari, « Mirchi Lagui ». Un dégradé du doux au brûlant, des piments et des flammes pour dire l'intensité des épices — en hindi comme en français.",
    descriptionEn:
      "A poster made during an exchange workshop in Mumbai: the French slang « Ça arrache » slips between two lines of Devanagari, « Mirchi Lagui ». A gradient from mild to burning, chillies and flames to convey the intensity of spice — in Hindi as in French.",
    dir: "/images/workshop-mumbai",
    total: 2,
  },
  synrgy: {
    num: "07",
    titleTop: "Synrgy",
    titleBottom: null,
    tagline: "Direction artistique & animation 3D — Projet fictif",
    taglineEn: "Art direction & 3D animation — Fictional project",
    year: "2026",
    meta: [
      { label: "Année", value: "2026" },
      { label: "Type", value: "Direction artistique complète" },
      { label: "Outils", value: "Blender — animation 3D" },
      { label: "Livrables", value: "Identité, canette, film, dossier" },
    ],
    metaEn: [
      { label: "Year", value: "2026" },
      { label: "Type", value: "Full art direction" },
      { label: "Tools", value: "Blender — 3D animation" },
      { label: "Deliverables", value: "Identity, can, film, book" },
    ],
    description:
      "SYNRGY, boisson énergisante fictive. « Drink smart. Go fast. » Création de toute la direction artistique — identité, typographie, palette électrique (cyan, magenta, bleu) — jusqu'au design de la canette Blueberry Ice / Power Max, modélisée et animée en 3D sous Blender.",
    descriptionEn:
      "SYNRGY, a fictional energy drink. « Drink smart. Go fast. » Building the whole art direction — identity, typography, electric palette (cyan, magenta, blue) — down to the Blueberry Ice / Power Max can design, modelled and animated in 3D with Blender.",
    video: "/videos/synrgy.mp4",
    videoWebm: "/videos/synrgy.webm",
    videoLabel: "Animation 3D Blender",
    videoLabelEn: "Blender 3D animation",
    pages: [
      "/images/synrgy/cans-front.webp",
      "/images/synrgy/cans-side.webp",
      "/images/synrgy/dossier-01.webp",
      "/images/synrgy/dossier-03.webp",
      "/images/synrgy/dossier-05.webp",
    ],
  },
  fisheye: {
    num: "08",
    titleTop: "Fisheye",
    titleBottom: "Voyage",
    tagline: "Magazine — Éditorial & rédactionnel",
    taglineEn: "Magazine — Editorial & copywriting",
    year: "2025",
    meta: [
      { label: "Année", value: "2025" },
      { label: "École", value: "ECV Bordeaux" },
      { label: "Type", value: "Éditorial & rédactionnel" },
      { label: "Support", value: "Magazine — n°91, une + 6 doubles pages" },
    ],
    metaEn: [
      { label: "Year", value: "2025" },
      { label: "School", value: "ECV Bordeaux" },
      { label: "Type", value: "Editorial & copywriting" },
      { label: "Format", value: "Magazine — issue 91, cover + 6 spreads" },
    ],
    description:
      "Projet d'école : réinventer un numéro de Fisheye, magazine existant, en gardant son ADN. J'ai porté ce numéro sur le voyage et ce qu'il nous procure — de la Guyane de mon enfance aux rues de Mumbaï. Maquette, direction photo et textes signés de ma main : « Travel », « Paix », « Places », « Temporalité », lettres manuscrites et souvenirs d'ailleurs.",
    descriptionEn:
      "A school project: reinventing an issue of Fisheye, an existing magazine, while keeping its DNA. I built this issue around travel and what it gives us — from the French Guiana of my childhood to the streets of Mumbai. Layout, photo direction and copy all my own: « Travel », « Peace », « Places », « Temporality », handwritten letters and memories from elsewhere.",
    pages: [
      "/images/fisheye/couv.webp",
      "/images/fisheye/02-03.webp",
      "/images/fisheye/08-09.webp",
      "/images/fisheye/04-05.webp",
      "/images/fisheye/06-07.webp",
      "/images/fisheye/10-11.webp",
      "/images/fisheye/humeur.webp",
      "/images/fisheye/une.webp",
    ],
    featured: [2, 3, 4, 5, 6],
  },
  aethera: {
    num: "09",
    titleTop: "Aethera",
    titleBottom: "Festival",
    tagline: "Illustration & identité — Festival fictif",
    taglineEn: "Illustration & identity — Fictional festival",
    year: "2026",
    meta: [
      { label: "Année", value: "2026" },
      { label: "École", value: "ECV Bordeaux" },
      { label: "Type", value: "Illustration & identité visuelle" },
      { label: "Support", value: "2 affiches + dossier de rendu" },
    ],
    metaEn: [
      { label: "Year", value: "2026" },
      { label: "School", value: "ECV Bordeaux" },
      { label: "Type", value: "Illustration & visual identity" },
      { label: "Format", value: "2 posters + process book" },
    ],
    description:
      "Aethera est un festival de musique expérimentale dont le concept repose sur la captation des phénomènes naturels : grâce à des dispositifs technologiques sensibles, les éléments — eau, feu, air, terre — deviennent des sources sonores. Variations de température, de vibration, de mouvement et d'humidité sont traduites en compositions musicales en temps réel : une expérience immersive où la nature devient musicienne, révélant et amplifiant l'activité permanente des éléments, invisible à l'œil nu, pour tisser un dialogue entre environnement, technologie et perception humaine. L'identité visuelle prolonge cette intention — rendre visible l'invisible, traduire graphiquement flux, ondes et interactions dans un langage organique et évolutif, à la croisée de l'art, de la science et de la nature. La palette puise dans les éléments : verts et jaunes pour la terre et l'énergie vivante, gris clair et noir pour la sobriété technique des capteurs. Deux typographies dialoguent enfin : un tracé calligraphique fluide, aux pleins et déliés semblables à des ondes liquides, pour la charge sensible et primaire du festival ; une typographie secondaire plus stable et lisible, écho rationnel au système de capteurs qui traduit les données naturelles en son.",
    descriptionEn:
      "Aethera is an experimental music festival built on capturing natural phenomena: through sensitive technological devices, the elements — water, fire, air, earth — become sound sources. Shifts in temperature, vibration, movement and humidity are translated into real-time musical compositions — an immersive experience where nature becomes the musician, revealing and amplifying the constant, invisible activity of the elements to weave a dialogue between environment, technology and human perception. The visual identity extends this intent — making the invisible visible, translating flows, waves and interactions into an organic, evolving formal language at the crossroads of art, science and nature. The palette draws directly from the elements: greens and yellows for the earth and living energy, light grey and black for the technical restraint of the sensors. Two typefaces finally converse: a fluid calligraphic stroke, its thicks and thins like liquid waves, for the festival's sensory, primal charge; and a steadier, more legible secondary type — a rational echo of the sensor system that turns natural data into sound.",
    pages: [
      "/images/aethera/affiche.webp",
      "/images/aethera/affiche-2.webp",
      "/images/aethera/page-11.webp",
      "/images/aethera/page-12.webp",
      "/images/aethera/page-13.webp",
      "/images/aethera/page-15.webp",
      "/images/aethera/page-17.webp",
    ],
    featured: [1, 2],
  },
};
